import { createAction, props } from '@ngrx/store';
import { RegistryRecords } from '@wam/shared';

export const setRegistryDataForService = createAction(
  '[Settings] Set registry data for service',
  props<RegistryRecords>(),
);
